<template>
  <div class="history" oncontextmenu="return false">
      <Navbar></Navbar>
      <div class="contents">
          <div class="bg"></div>
          <div class="content">
              <div class="middle">
                  <div class="aboutus">
                      <span class="about-line"></span>
                      <div class="title">发展历程</div>
                      <p>DEVELLOPMENT HISTORY</p>
                      <span class="about-line"></span>
                  </div>
                  <div class="intro">
                      <div class="left">
                          <div class="left-item">
                              <div class="left-date"></div>
                              <p>第一代维码器投入研发</p>
                              <span class="left-item-line"></span>
                          </div>
                          <div class="left-item">
                              <div class="left-date"></div>
                              <p>维码器获得专利《实用新型专利证书》</p>
                              <span class="left-item-line"></span>
                          </div>
                          <div class="left-item">
                              <div class="left-date"></div>
                              <p>维码器被认定为广东省高新科技产品</p>
                              <span class="left-item-line"></span>
                          </div>
                          <div class="left-item">
                              <div class="left-date"></div>
                              <p>全国装机量突破10W+台</p>
                              <span class="left-item-line"></span>
                          </div>
                      </div>

                      <div class="middle-items">
                          <div class="middle-item">
                                <div class="circle"></div>
                                <span class="middle-item-line"></span>
                                <div class="circle-ph"><div class="circle-ph-dot"></div></div>
                                <span class="middle-item-line"></span>
                                <div class="circle-ph"><div class="circle-ph-dot"></div></div>
                                <span class="middle-item-line"></span>
                                <div class="circle-ph"><div class="circle-ph-dot"></div></div>
                                <span class="middle-item-line"></span>
                                <div class="circle-ph"><div class="circle-ph-dot"></div></div>
                                <span class="middle-item-line"></span>
                                <div class="circle-ph"><div class="circle-ph-dot"></div></div>
                                <span class="middle-item-line"></span>
                                <div class="circle-ph"><div class="circle-ph-dot"></div></div>
                                <span class="middle-item-line"></span>
                                <div class="circle-ph"><div class="circle-ph-dot"></div></div>
                                <span class="middle-item-line"></span>
                                <div class="circle-ph"><div class="circle-ph-dot"></div></div>
                                <span class="middle-item-line"></span>
                                <div class="circle"></div>
                          </div>
                          <div class="middle-bottom">FUTURE</div>
                      </div>

                      <div class="right">
                          <div class="right-item">
                              <div class="right-date"></div>
                              <p>维码器正式投入市场</p>
                              <span class="right-item-line"></span>
                          </div>
                          <div class="right-item">
                              <div class="right-date"></div>
                              <p>设备铺设量达到1W+台</p>
                              <span class="right-item-line"></span>
                          </div>
                          <div class="right-item">
                              <div class="right-date"></div>
                              <p>第二代带闪付功能维码器正式投入市场</p>
                              <span class="right-item-line"></span>
                          </div>
                          <div class="right-item">
                              <div class="right-date"></div>
                              <p>月订单交易流水突破1.8亿<br/>全国各地铺设20W+台设备，服务商家数量超过5W+</p>
                              <!--<p></p>-->
                              <span class="right-item-line"></span>
                          </div>
                      </div>
                  </div>        
                           
              </div>
              <thr></thr>
          </div>
           
      </div>
     <foot></foot>
  </div>
</template>

<script>
import Navbar from '../Navbar'
import Foot from '../hardProduct/foot'
import Thr from './thr'
export default {
  name:'history',
  components:{Navbar,Foot,Thr}
}
</script>


<style scoped>

.contents{
    width: 100%;
    height: 100%;
}
.contents .bg{
    width: 100%;
    height: 800px;
    background: url(./images/bg2.jpg) no-repeat;
    background-size: cover;
}
.content{
    width:100%;
    height: 100%;   /*为什么写100%没有高度呢*/
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}
.middle{
    width: 1200px;
	height: 1434px;
	background-color: #ffffff;
    margin-top: -200px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
}
.aboutus{
    width: 499px;
	height: 133px;
    background: url(images/titlebg.png) no-repeat;
    background-size: 499px 78px;
    background-position: center;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
    margin-top: 100px;
}
.aboutus .about-line{
    width: 24px;
	height: 3px;
	background-color: #1a8bff;
    display: block;
}
.aboutus .title{
    font-family: 微软雅黑;
    font-size: 40px;
	letter-spacing: 0px;
	color: #333333;
}
.aboutus p{
    font-size: 14px;
	font-family: Arial;
	letter-spacing: 1px;
	color: #333333;
    display: block;
    margin-top: -18px;
}
.intro{
    width: 1200px;
	height: 1112px;
    position: relative;
}
/* .left,.middle-items,.right{
    float: left;
} */
.left-item .left-item-line,.right-item .right-item-line{
    width: 20px;
	height: 2px;
	background-color: #1a8bff;
    display: block;
}
.left-item p,.right-item p{
    color: #666666;
    font-size: 16px;
    font-family: 微软雅黑;
    letter-spacing: 0px;
    white-space:nowrap; 
}
.left .left-item .left-date{
    width:129px;
    height: 29px;
}
.left{
    width: 314px;
    height: 788px;
    padding-right: 49px;
        display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-end;
    position: absolute;
    top: 105px;
    left:278px;
    box-sizing: border-box;
}
.left .left-item{
    height: 86px;
    display: flex;
    justify-content: space-around;
    align-items: flex-end;
    flex-direction: column;
}
.left .left-item:nth-child(1) .left-date{
    background: url(images/2015-06.png) no-repeat;
    /* background-size: cover; */
        background-size: 100% 100%;
    background-position: center;
}
.left .left-item:nth-child(2) .left-date{
    background: url(images/2016-03.png) no-repeat;
    /* background-size: cover; */
        background-size: 100% 100%;
    background-position: center;
}
.left .left-item:nth-child(3) .left-date{
    background: url(images/2016-12.png) no-repeat;
    /* background-size: cover; */
        background-size: 100% 100%;
    background-position: center;
}
.left .left-item:nth-child(4) .left-date{
    background: url(images/2017-06.png) no-repeat;
    /* background-size: cover; */
        background-size: 100% 100%;
    background-position: center;
}
.middle-items{
    width: 17px;
    height: 1112px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
        position: absolute;
    left: 592px;
}
.middle-items .middle-item{
        height: 1070px;
        display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
.middle-items .middle-item .circle{
    width: 17px;
	height: 17px;
	border: 1px solid #eaeaea;
    border-radius:50%;
}
.middle-item .middle-item-line{
    width: 1px;
	height: 100px;
	background-color: #eaeaea;
    display: block;
}
.middle-item .circle-ph{
    width: 17px;
	height: 17px;
    border: 1px solid #198bfe;
    border-radius:50%;
    display: flex;
    justify-content: center;
    align-items: center;
}
.middle-item .circle-ph .circle-ph-dot{
    width:9px;
    height: 9px;
    background: #198bfe;
    border-radius: 50%;
}
.middle-bottom{
    color: #333333;
    font-size: 16px;
    font-family: Arial;
}
.right{
    width:419px;
    height: 816px;
    padding-left: 50px;
     display: flex;
    flex-direction: column;
    justify-content: space-between;
    box-sizing: border-box;
    position: absolute;
    top: 222px;
    left: 609px;
}

.right .right-item{
    height: 86px;
    display: flex;
    justify-content: space-around;
    /* align-items: flex-end; */
    flex-direction: column;
}
.right .right-item:last-child{
    height: 114px;
}
.right .right-item .right-date{
    width:129px;
    height: 29px;
}
.right .right-item:nth-child(1) .right-date{
    background: url(images/2015-10.png) no-repeat;
    /* background-size: cover; */
        background-size: 100% 100%;
    background-position: center;
}
.right .right-item:nth-child(2) .right-date{
    background: url(images/2016-08.png) no-repeat;
    /* background-size: cover; */
        background-size: 100% 100%;
    background-position: center;
}
.right .right-item:nth-child(3) .right-date{
    background: url(images/2017-04.png) no-repeat;
    /* background-size: cover; */
        background-size: 100% 100%;
    background-position: center;
}
.right .right-item:nth-child(4) .right-date{
    background: url(images/2018-03.png) no-repeat;
    /* background-size: cover; */
        background-size: 100% 100%;
    background-position: center;
}

/* 手机 */
@media screen and (max-width:768px){
    .history .header{
    display: none;
}
.history{
    margin-top: 48px;
}
.contents .bg{
width: 100%;
height: 205px;
background: url(./images/phone/BG2.png) no-repeat;
background-size: 100%;
}
.contents{
height: auto;
}
.content{
height: auto;
}
.middle{
    width: 90%;
    height: auto;
    margin-top: -70px;
}
.aboutus{
    width: 80%;
	height: 66px;
    background: url(images/titlebg.png) no-repeat;
    background-size: 249px 39px;
    background-position: center;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
    margin-top: 35px;
}
.aboutus .about-line{
    width: 12px;
	height: 1.5px;
	background-color: #1a8bff;
    display: block;
}
.aboutus .title{
    font-family:'Times New Roman', Times, serif;
    font-size: 20px;
	letter-spacing: 0px;
	color: #333333;
}
.aboutus p{
    font-size: 7px;
	font-family: Arial;
	letter-spacing: 1px;
	color: #333333;
    display: block;
    margin-top: -9px;
     font-family:'Times New Roman', Times, serif;
}
.intro{
    width: 100%;
    height:auto;
    margin-top: 38px;
    display: flex;
    justify-content: center;
    align-items: center;
}
.middle-items {
    width: 15px;
    height: 660px;
    position: relative;
    left: 0px;
}
.middle-items  .middle-item{
    width: 15px;
    height: 630px;
}
.middle-bottom{
    font-size: 11px;
    letter-spacing: 0.5px;
}
.middle-items .middle-item .circle{
    width: 15px;
    height: 15px;
}
.middle-item .circle-ph{
    width: 15px;
    height: 15px;
}
.middle-item .circle-ph .circle-ph-dot{
    width: 7px;
    height: 7px;
}

.middle-item .middle-item-line{
    height: 50px;
}
.left .left-item .left-date,.right .right-item .right-date{
    width: 65px;
    height: 15px;
}
.left-item p, .right-item p{
    font-size: 11px;
    white-space: normal;
     font-family:'Times New Roman', Times, serif;
     text-align: right;
}
.right-item p{
    text-align: left;
}
.left-item .left-item-line, .right-item .right-item-line{
    width: 10px;
    height: 1px;
}
.left{    
    width: 40%;
    height: 470px;
    padding-right: 15px;
        position: relative;
    top: -40px;
    left: 0;
    box-sizing: border-box;
}
.right{
        width: 40%;
    height: 514px;
    padding-left: 0px;
    position: relative;
    top: 40px;
    left: 15px;
}

.left .left-item,.right .right-item{
    height: 60px;
}
}
</style>



// WEBPACK FOOTER //
// src/components/aboutUs/history.vue